import { Handle, Position, useUpdateNodeInternals } from '@xyflow/react';
import { memo, useEffect } from 'react';
import { Globe } from 'lucide-react';

const ApiNode = ({ id, data }) => {
  const updateNodeInternals = useUpdateNodeInternals();
  const cases = data.responseCases || [];

  useEffect(() => {
    updateNodeInternals(id);
  }, [cases, id, updateNodeInternals]);

  return (
    <div className="bg-white rounded-xl shadow-lg border-2 border-emerald-500 w-64 overflow-hidden min-w-[280px]">
      <div className="bg-emerald-500 p-2 flex items-center gap-2">
        <Globe className="h-4 w-4 text-white" />
        <span className="text-xs font-bold text-white uppercase tracking-wider">
          API Request
        </span>
      </div>
      <div className="p-4 flex flex-col gap-2">
        <div>
          <div className="text-sm font-semibold text-gray-900 mb-1">
            {data.method || 'GET'}
          </div>
          <div className="text-xs text-gray-500 truncate" title={data.url}>
            {data.url || 'No URL configured'}
          </div>
        </div>

        {cases.length > 0 && (
          <div className="mt-2 pt-2 border-t border-gray-100 flex flex-col gap-2">
            {cases.map((c, idx) => (
              <div
                key={c.id}
                className="relative bg-emerald-50 border border-emerald-100 p-2 rounded-lg pr-4"
              >
                <div className="text-[10px] font-bold text-emerald-800 uppercase tracking-widest truncate">
                  Case {idx + 1}
                </div>
                <div className="text-xs text-emerald-600 truncate mt-0.5">
                  {c.variablePath} {c.operator} {c.value}
                </div>
                <Handle
                  type="source"
                  position={Position.Right}
                  id={c.id}
                  className="w-3 h-3 bg-emerald-500 border-2 border-white -right-1.5"
                  style={{ top: '50%' }}
                />
              </div>
            ))}
          </div>
        )}

        <div className="mt-1 relative p-2 bg-gray-50 border border-gray-200 rounded-lg pr-4">
          <div className="text-[10px] font-bold text-gray-500 uppercase tracking-widest truncate">
            {cases.length > 0 ? 'Default / No Match' : 'Next Node'}
          </div>
          <Handle
            type="source"
            position={Position.Right}
            id="default"
            className="w-3 h-3 bg-gray-400 border-2 border-white -right-1.5"
            style={{ top: '50%' }}
          />
        </div>
      </div>
      <Handle
        type="target"
        position={Position.Top}
        className="w-3 h-3 bg-gray-300 border-2 border-white"
      />
    </div>
  );
};

export default memo(ApiNode);
